import { useEffect, useState } from 'react';
import { getSampleQuestions, type SampleQuestion } from '../services/api';

interface UseSampleQuestionsResult {
  questions: SampleQuestion[];
  loaded: boolean;
}

/**
 * Fetches a random mixed-domain pool of sample questions for the V2
 * landing screen. The returned list is stable for the session — consumers
 * (static chips + animated placeholder rotation) share the same pool but
 * can subset/shuffle it however they want.
 *
 * Default is 20 so the animated placeholder has lots of variety; the caller
 * typically slices off the first 6 for the static chip row.
 */
export function useSampleQuestions(count = 20): UseSampleQuestionsResult {
  const [questions, setQuestions] = useState<SampleQuestion[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getSampleQuestions(count)
      .then((list) => {
        if (cancelled) return;
        setQuestions(list);
        setLoaded(true);
      })
      .catch(() => {
        if (cancelled) return;
        setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, [count]);

  return { questions, loaded };
}
